export { default } from './Configurator';
